import { ZendeskViaChannelId } from '../../../../com/faire/vendor/zendesk/ZendeskViaChannelId';

export namespace ICreateTicketRequest {
  /**
   * Return an instance of ICreateTicketRequest with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<ICreateTicketRequest>
  ): ICreateTicketRequest =>
    ({
      tags: [],
      ...(partial ?? {}),
    } as ICreateTicketRequest);
}

export interface ICreateTicketRequest {
  /**
   * The requester info of the ticket
   */
  name: string | undefined;
  email: string | undefined;
  locale: string | undefined;
  /**
   * The comment of the ticket
   */
  comment_body: string | undefined;
  is_comment_public: boolean | undefined;
  attachment_token: string | undefined;
  /**
   * The custom ticket fields of the ticket
   */
  user_name: string | undefined;
  issue_type: string | undefined;
  brand_order_token: string | undefined;
  web_url: string | undefined;
  platform: string | undefined;
  os_version: string | undefined;
  app_version: string | undefined;
  /**
   * @deprecated
   */
  issue_report_token: string | undefined;
  /**
   * @protobufOption (.faire.common.tokenType) = BRAND
   */
  brand_token: string | undefined;
  /**
   * @protobufOption (.faire.common.tokenType) = RETAILER
   */
  retailer_token: string | undefined;
  phone_number: string | undefined;
  order_token: string | undefined;
  /**
   * The tags for the dropdown fields of the ticket
   */
  tags: Array<string>;
  user_type_tag: string | undefined;
  based_in_tag: string | undefined;
  external_id: string | undefined;
  subject: string | undefined;
  description: string | undefined;
  ticket_form_id: number | undefined;
  /**
   * Ticket creation metadata
   */
  via_channel_id: keyof typeof ZendeskViaChannelId | undefined;
}
